import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card, Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add as AddIcon, Edit } from "@mui/icons-material";
import { GetLevels2 } from "../../redux/actions/GetLevels2Action";
import AddLevel2Modal from "components/AddLevel2Modal";
import EditLevel2Modal from "components/EditLevel2Modal";

const selectedCountry = localStorage.getItem("selectedCountry");

const formatDate = (params) => {
  if (!params.value) return "";
  const date = new Date(params.value);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

const Levels2Table = () => {
  const dispatch = useDispatch();
  const levels2Response = useSelector((state) => state.levels2.levels2);
  const fetchStatus = useSelector((state) => state.levels2.status);
  const [levels2, setLevels2] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedLevel2, setSelectedLevel2] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      await dispatch(GetLevels2());
    };

    loadData();
  }, [dispatch]);

  useEffect(() => {
    if (!Array.isArray(levels2Response)) {
      return;
    }

    const listLevels2 = levels2Response.map((element) => {
      const idmenuLevel2 = element.idmenuLevel2 ?? element.idMenuLevel2;

      return {
        id: idmenuLevel2,
        idmenuLevel2,
        name: element.name ?? "",
        isActive: element.isActive ?? true,
        countryName: selectedCountry ?? "",
        idCountry: element.idcountry ?? element.idCountry ?? "",
        createdBy: element.createdBy ?? element.CreatedBy ?? "",
        createdDate: element.createdDate ?? element.CreatedDate ?? "",
        modifiedBy: element.modifiedBy ?? element.ModifiedBy ?? "",
        modifiedDate: element.modifiedDate ?? element.ModifiedDate ?? "",
      };
    });

    setLevels2(listLevels2);
  }, [levels2Response]);

  const handleEditOpen = (level2Data) => {
    setSelectedLevel2(level2Data);

    setOpenEditModal(true);
  };

  const columns = [
    {
      field: "idmenuLevel2",
      headerName: "ID",
      width: 90,
    },
    {
      field: "name",
      headerName: "Category",
      flex: 1,
      minWidth: 90,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 120,
    },

    {
      field: "createdDate",
      headerName: "Created Date",
      width: 180,
      renderCell: formatDate,
    },

    {
      field: "modifiedBy",
      headerName: "Modified By",
      width: 120,
    },
    {
      field: "modifiedDate",
      headerName: "Modified Date",
      width: 180,
      renderCell: formatDate,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          sx={{
            color: "#ffffff",
            backgroundColor: "#4b4bfa",
            "&:hover": { backgroundColor: "#3e3ed9" },
          }}
          onClick={() => handleEditOpen(params.row)}
        >
          <Edit />
        </Button>
      ),
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <div style={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <h1 style={{ marginBottom: "0.5%" }}>Category Management</h1>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4b4bfa",
                  color: "#ffffff",

                  "&:hover": { backgroundColor: "#3e3ed9" },
                }}
                onClick={() => setOpenAddModal(true)}
              >
                <AddIcon />
              </Button>
            </Box>

            <DataGrid
              rows={levels2}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              disableSelectionOnClick
              loading={fetchStatus === "loading"}
              sx={{
                "& .MuiCircularProgress-root": { color: "#4b4bfa" },
                mt: 2,
              }}
            />
          </div>
        </Card>
      </Grid>

      <AddLevel2Modal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />

      <EditLevel2Modal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);

          setSelectedLevel2(null);
        }}
        level2Data={selectedLevel2}
      />
    </Grid>
  );
};

export default Levels2Table;
